import { Reducer } from 'redux';
import {
  PharmacyPatientsAction,
  PharmacyPatientsActionType,
  PharmacyPatientsStore,
} from './pharmacyPatientsTypes';

const initialState: PharmacyPatientsStore = {
  patients: [],
  uploads: [],
  error: null,
  isLoading: false,
  isUploadsLoading: false,
};

const pharmacyPatientsReducer: Reducer<
  PharmacyPatientsStore,
  PharmacyPatientsAction
> = (state = initialState, action) => {
  switch (action.type) {
    case PharmacyPatientsActionType.SET_PHARMACY_PATIENTS: {
      const { patients } = action.payload;
      return {
        ...state,
        patients,
      };
    }
    case PharmacyPatientsActionType.PHARMACY_PATIENTS_SET_LOAD_STATE: {
      const { isLoading } = action.payload;
      return {
        ...state,
        isLoading,
      };
    }
    case PharmacyPatientsActionType.PHARMACY_PATIENTS_API_ERR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
      };
    }
    case PharmacyPatientsActionType.SET_PHARMACY_UPLOADS: {
      const { uploads } = action.payload;
      return {
        ...state,
        uploads,
      };
    }
    case PharmacyPatientsActionType.PHARMACY_UPLOADS_SET_LOAD_STATE: {
      const { isUploadsLoading } = action.payload;
      return {
        ...state,
        isUploadsLoading,
      };
    }
    default:
      return state;
  }
};

export default pharmacyPatientsReducer;
